/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useFeatureFlag } from '../components/FeatureFlags/index.js';

function createComponentToggle(spec) {
  var name = spec.name,
      _spec$flag = spec.flag,
      flag = _spec$flag === void 0 ? 'enable-v11-release' : _spec$flag,
      next = spec.next,
      classic = spec.classic;

  function ComponentToggle(props, ref) {
    var enabled = useFeatureFlag(flag);

    if (enabled) {
      if (next) {
        return /*#__PURE__*/React__default.createElement(next, _objectSpread2(_objectSpread2({}, props), {}, {
          ref: ref
        }));
      }

      return null;
    }

    return /*#__PURE__*/React__default.createElement(classic, _objectSpread2(_objectSpread2({}, props), {}, {
      ref: ref
    }));
  }

  var wrappedComponent = /*#__PURE__*/React__default.forwardRef(ComponentToggle);
  wrappedComponent.displayName = "FeatureToggle(".concat(name, ")");
  return wrappedComponent;
}

export { createComponentToggle };
